import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { prepareHeaders } from 'utils';

const LinkedInCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    let state = query.get('state');

    // Save state in session storage if it's in the query params
    if (state) {
      sessionStorage.setItem('linkedin_state', state);
    } else {
      // If state is not in the query params, retrieve it from session storage
      const storedState = sessionStorage.getItem('linkedin_state');
      if (storedState) {
        state = storedState;
      }
    }

    const sendCodeToBackend = async () => {
      const headers = await prepareHeaders(new Headers());
      headers.append('Accept', '*/*');
      headers.append('Content-Type', 'application/json');

      if (code && state) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/accountant_profiles/linkedin_callback`,
            {
              method: 'POST',
              headers,
              body: JSON.stringify({ code, state }),
              //credentials: 'include', // Ensure credentials are included in the request
            },
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log('LinkedInCallback: response data', data);
          if (data.message) {
            navigate('/profile');
          } else {
            console.error('LinkedIn sync failed:', data.error);
          }
        } catch (error) {
          console.error('LinkedIn sync error:', error);
        }
      } else {
        console.error('Missing code or state parameter');
      }
    };

    sendCodeToBackend();
  }, [location.search, navigate]);

  return <div>Loading...</div>;
};

export default LinkedInCallback;
